import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import {
  GetCreatePaymentOrderRequestType,
  GetCreatePaymentOrderResponseType
} from '../../../services/PaymentServices/APIService/types';
import { getAPIErrorMessage } from '../../../utils/ApiErrorUtils';

import usePaymentServices from '../usePaymentServices';

interface UseCreatePaymentOrderAndGetDetailsInterface {
  createPaymentOrderAndGetDetailsApi: UseMutateAsyncFunction<
    GetCreatePaymentOrderResponseType,
    unknown,
    GetCreatePaymentOrderRequestType,
    unknown
  >;
  error: string | null;
  status: MutationStatus;
}

const useCreatePaymentOrderAndGetDetails =
  (): UseCreatePaymentOrderAndGetDetailsInterface => {
    const { paymentServices } = usePaymentServices();

    const createPaymentOrderAndGetDetails = (
      requestObject: GetCreatePaymentOrderRequestType
    ) => {
      return paymentServices.createPaymentOrderAndGetDetails(requestObject);
    };

    const { mutateAsync, error, status } = useMutation(
      createPaymentOrderAndGetDetails,
      {
        mutationKey: ['createPaymentOrderAndGetDetailsApi']
      }
    );

    return {
      createPaymentOrderAndGetDetailsApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useCreatePaymentOrderAndGetDetails };
